import { render, staticRenderFns } from "./MealHolidayConfig.vue?vue&type=template&id=253d7dea&scoped=true"
import script from "./MealHolidayConfig.vue?vue&type=script&lang=js"
export * from "./MealHolidayConfig.vue?vue&type=script&lang=js"
import style0 from "./MealHolidayConfig.vue?vue&type=style&index=0&id=253d7dea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253d7dea",
  null
  
)

export default component.exports